import request from '@/utils/request'

// 文章列表
export function artList(params) {
  return request({
    url: '/posts/list',
    method: 'get',
    params
  })
}

// 文章详情
export function artDetail(id) {
  return request({
    url: '/posts/info',
    method: 'post',
    data: { id }
  })
}

// 修改文章
export function editArt(data) {
  return request({
    url: '/posts/update',
    method: 'post',
    data
  })
}

// 审核文章
export function checkArt(data) {
  return request({
    url: '/posts/check',
    method: 'post',
    data
  })
}

// 删除文章
export function delArt(id) {
  return request({
    url: '/posts/del',
    method: 'post',
    data: { id }
  })
}

// 恢复文章
export function restore(id) {
  return request({
    url: '/posts/recover',
    method: 'post',
    data: { id }
  })
}

// 置顶文章
export function topArt(id) {
  return request({
    url: '/posts/top',
    method: 'post',
    data: { id }
  })
}

// 点赞记录
export function likeList(params) {
  return request({
    url: '/posts/like-up-record',
    method: 'get',
    params
  })
}

// 评论列表
export function reviewList(params) {
  return request({
    url: '/comment/list',
    method: 'get',
    params
  })
}

// 操作评论
export function dealView(data) {
  return request({
    url: '/comment/update',
    method: 'post',
    data
  })
}

// 评论详情
export function commentDetail(id) {
  return request({
    url: '/comment/detail',
    method: 'get',
    params: { id }
  })
}

// 浏览记录-列表
export function readRecordList(data) {
  return request({
    url: '/posts/read-record',
    method: 'post',
    data
  })
}
